import { useState } from 'react';

import styled from 'styled-components';

import { IconVisibilityHidden } from '@components/icons/visibility-hidden';
import { IconVisibilityShown } from '@components/icons/visibility-shown';
import { TextFieldProps, TextField } from '@components/text-field';
import { transitionSlow } from '@utils/transitions';
import { Transient } from '@utils/types';

export type PasswordFieldProps = TextFieldProps & { hideVisibilityOnEmpty?: boolean };

export function PasswordField({ hideVisibilityOnEmpty = false, ...rest }: PasswordFieldProps) {
  const [show, setShow] = useState(false);

  return (
    <Container $hideVisibilityOnEmpty={hideVisibilityOnEmpty}>
      <TextField
        {...rest}
        type={show ? 'text' : 'password'}
        iconRight={
          show ? (
            <IconVisibilityShown
              onClick={() => {
                setShow(false);
              }}
            />
          ) : (
            <IconVisibilityHidden
              onClick={() => {
                setShow(true);
              }}
            />
          )
        }
      />
    </Container>
  );
}

const Container = styled.div<Transient<PasswordFieldProps, 'hideVisibilityOnEmpty'>>(
  ({ $hideVisibilityOnEmpty }) => {
    return {
      svg: {
        transition: transitionSlow('opacity'),
        opacity: 1,
      },
      ...($hideVisibilityOnEmpty && {
        'input:placeholder-shown + svg': {
          opacity: 0,
        },
      }),
    };
  },
);
